import "../css/blockimagevideo.css";
import { useState, useEffect } from "react";

function BlockImageVideo(props) {
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 900);

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth > 900);
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="wrapper-block-video">
      {/* VIDEO SOLO EN DESKTOP */}
      {isDesktop ? (
        <video autoPlay muted loop playsInline className="bg-video">
          <source src={props.video} type="video/mp4" />
        </video>
      ) : (
        /* IMAGEN SOLO EN MÓVIL */
        <img src={props.src} alt="background" className="bg-image" />
      )}

      <div className="wrapper-block-content">
        <div>
          <div>{props.content}</div>{" "}
        </div>
      </div>
    </div>
  );
}

export default BlockImageVideo;
